module.exports = __webpack_public_path__ + "img/Groupe 91.5b4c691a.svg";